import { render, staticRenderFns } from "./adminAlianzas.vue?vue&type=template&id=6960a816&"
import script from "./adminAlianzas.vue?vue&type=script&lang=js&"
export * from "./adminAlianzas.vue?vue&type=script&lang=js&"
import style0 from "./adminAlianzas.vue?vue&type=style&index=0&id=6960a816&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports